import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { PaleteEnum } from "../../../interfaces/Enums";
import { useAuthGenerateCode } from "../../../queries/Auth/generateCode";
import { IEmailValidation, emailValidationFormSchema } from "./validation";

export default function GenerateCode() {
  const { generateCode } = useAuthGenerateCode();

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<IEmailValidation>({
    resolver: yupResolver(emailValidationFormSchema),
  });

  const onSubmit = (data: IEmailValidation) => {
    generateCode(data.email);
  };

  return (
    <Grid container flexDirection={"column"} p={4}>
      <Typography variant="h5" textAlign={"center"} fontWeight={"bold"} mb={4}>
        Crie sua conta agora mesmo
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container mb={1}>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <>
                <TextField
                  {...field}
                  value={field.value || ""}
                  variant="outlined"
                  placeholder="Email"
                  label="Email"
                  error={!!errors.email}
                  fullWidth
                />
                <Typography variant="caption" mt={0.5} color={"red"}>
                  {errors.email?.message}
                </Typography>
              </>
            )}
          />
        </Grid>
        <Grid item container flexDirection={"column"} rowSpacing={2}>
          <Grid item>
            <Button
              variant={"contained"}
              sx={{
                bgcolor: PaleteEnum.bluePrimary,
                "&:hover": {
                  bgcolor: PaleteEnum.bluePrimary,
                },
              }}
              fullWidth
              type="submit"
            >
              Continuar
            </Button>
          </Grid>
          <Grid item>
            <Link
              to="/"
              style={{ color: PaleteEnum.bluePrimary, textDecoration: "none" }}
            >
              Já possui uma conta?
            </Link>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
}
